import { Button, Card } from "@nfp-tracker/components";
import { Capacitor } from "@capacitor/core";

interface UpdateRequiredScreenProps {
  updateMessage?: string | null;
  storeUrl?: string | null;
}

const DEFAULT_MESSAGE =
  "A required update is available. Please update to continue using the app.";

export const UpdateRequiredScreen = ({ updateMessage, storeUrl }: UpdateRequiredScreenProps) => {
  const isNative = Capacitor.isNativePlatform();

  return (
    <div className="flex min-h-screen items-center justify-center bg-background p-6">
      <Card className="max-w-sm space-y-4 p-6 text-center">
        <h1 className="text-xl font-semibold">Update Required</h1>
        <p className="text-sm text-muted-foreground">{updateMessage || DEFAULT_MESSAGE}</p>
        {isNative ? (
          <Button
            className="w-full"
            disabled={!storeUrl}
            onClick={() => {
              if (storeUrl) window.open(storeUrl, "_blank");
            }}
          >
            Update Now
          </Button>
        ) : (
          <Button className="w-full" onClick={() => window.location.reload()}>
            Refresh
          </Button>
        )}
      </Card>
    </div>
  );
};
